
export const isExpired = (tokenExpDate: number): boolean => {
  const currentDateInMs = new Date().getTime();
  return tokenExpDate * 1000 < currentDateInMs;
};

